"use client";

import type { ImpactPartnerProfessor } from "@mw/shared/payload-types";

import dynamic from "next/dynamic";

const ImpactPartnerProfessorsListView = dynamic(() => import("./ImpactPartnerProfessorsListView"));

export const ImpactPartnerProfessorsListClient = (props: {
  allProfessors: ImpactPartnerProfessor[];
  displayProfessors: ImpactPartnerProfessor[];
}) => {
  return <ImpactPartnerProfessorsListView {...props} />;
};
